import * as React from 'react';
export const SXSvg = React.forwardRef(function SXSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.64 2.54A2 2 0 0 0 0 4v8a2 2 0 0 0 .64 1.46l.36-.3V2.84l-.36-.3Z',
      fill: '#EAEEF3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1 2.84v10.32L7.11 8 1 2.84Z',
      fill: '#F6F9FC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.64 2.54A2 2 0 0 1 2 2h12a2 2 0 0 1 2 2v4H7.11L.64 2.54Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.64 13.46A2 2 0 0 0 2 14h12a2 2 0 0 0 2-2V8H7.11L.64 13.46Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.75 9.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z',
      fill: '#45B2E8',
    }),
  );
});
SXSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var SX = {
  category: 'flag',
  colorable: false,
  name: 'SX',
  svg: SXSvg,
};
